import React, { useState, useEffect } from "react"
import { useParams } from 'react-router-dom';
import { get_printable_by_id } from '../../services/printables_service'
import "./single_printable_page.css"
import NotFound from "./NotFound";

const SinglePrintablePage = () => {

    const { id } = useParams();

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true);
    const [loadingError, setLoadingError] = useState(null);

    const fetchData = async () => {
        try {
            const resp = await get_printable_by_id(id)
            if (resp.status !== 200) {
                throw new Error(`HTTP error! status: ${resp.status}`);
            }
            setData(resp.data)
        } catch (err) {
            setLoadingError(err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [id])

    return (
        <>
            {loading === true ? (<div>loading...</div>) :
                (loadingError || !data) ? (<NotFound />) : (
                    <React.Fragment>
                        <h1 className="single-printable-page">{data.title}</h1>
                        <div className="single-printable-wrapper">
                            <img
                                className="single-printable-page"
                                alt={`${data.title}`}
                                src={data.url} />
                        </div>
                        <div className="single-printable-wrapper">
                            <a
                                className="btn"
                                href={data.url} download>download</a>
                        </div>
                        {data.link_url && <div className="single-printable-wrapper">
                            <a target="_blank" rel="noreferrer" href={data.link_url}>{data.link_text || data.link_url}</a>
                        </div>}
                    </React.Fragment>
                )
            }
        </>
    )

}

export default SinglePrintablePage;